import { Pagination } from "@mui/material";
import React, { useEffect } from "react";
// import { transactions } from "../../Utils/data";
import { ArchiveIcon, CalendarIcon, HomeIcon, PersonIcon, SewingPinFilledIcon } from "@radix-ui/react-icons";
import { NavLink, useLocation } from "react-router-dom";
import { checkTagValidity } from "../../Utils/Utils";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { useIntentionStore } from "../../store/intentionStore";
import { Pbo } from "../Widget/Pbo";
import { Periode } from "../Widget/Periode";

export const Abonnement = ({ status, step, perm }) => {
    const intentions = useIntentionStore()
    const location = useLocation()
    useEffect(() => {
        intentions.intentionList({ page: 0, param: ``, size: 8 }, `&statusConfirmation=&status=${status}&date=&isActive=true&sousMenu=${location.pathname.split('/')[2]}`)
    }, [status]);

    const more = (page) => {
        intentions.intentionList({ page: page - 1, param: "", size: 8 }, `&statusConfirmation=&status=${status}&date=&isActive=true&sousMenu=${location.pathname.split('/')[2]}`)
    };

    return (
        <>

            <div className=" grid  lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
                {
                    intentions?.data?.data?.length === 0 ?
                        <div className="">
                            <p className="text-sm ">Aucune donnée</p>
                        </div>
                        : intentions?.data?.data?.length !== 0 && !intentions?.loading ?
                            intentions?.data?.data?.map((item) => (
                                <div className='relative bg-white rounded-xl border-slate-200 border shadow-md'>
                                    <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                                        <p className="text-[12px] font-semibold">N° {item?.numeroTicket}</p>
                                        <div className="ml-auto flex items-center gap-2">
                                            <div className={` px-1 border  rounded-full py-[2px] text-xs ${item?.statusConfirmation === "CONFIRMER" ? 'text-green-600' : 'text-gray-500'}  font-semibold`}>{item?.statusConfirmation?.toLowerCase().replace("_", " ").replace("er", "é")}</div>
                                        </div>
                                    </div>
                                    <div className=" px-3 py-2 ">
                                        <div className="items-center gap-2 space-y-3">
                                            <Periode item={item} />
                                            <Pbo pbo={item?.eligibilite?.pbo?.nom} port={item?.brin} />
                                            <div className="flex gap-1 my-3">
                                                <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                                                <div>
                                                    <p className="text-[13px] font-medium">{item?.client?.nomPrenoms}</p>
                                                    <p className="text-xs flex font-semibold gap-2"><span>{item?.client?.numero}</span> {" | "} <span>{item?.client?.secondNumero}</span> </p>
                                                </div>
                                            </div>
                                            <h1 className="text-xs flex gap-1 items-center my-2">
                                                Forfait :{" "}
                                                {item?.forfait?.designation} - {item?.forfait?.categorie?.replace("_", " ").toLowerCase()}
                                            </h1>
                                            {
                                                status === 'EN_ATTENTE_DE_SURVEY' || status === 'EN_ATTENTE_DE_RACCORDEMENT' ? (
                                                    <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                                                        <p className="text-xs flex gap-1 items-center font-medium"><CalendarIcon />{
                                                            status === 'EN_ATTENTE_DE_SURVEY' ? item?.listRendezVous.find(e => e.typeRendezVous === 'SURVEY')?.date + ' de ' + item?.listRendezVous.find(e => e.typeRendezVous === 'SURVEY')?.crenau?.heureDebut + ' à ' + item?.listRendezVous.find(e => e.typeRendezVous === 'SURVEY')?.crenau?.heureFin
                                                                : item?.listRendezVous.find(e => e.typeRendezVous === 'RACCORDEMENT')?.date + ' de ' + item?.listRendezVous.find(e => e.typeRendezVous === 'RACCORDEMENT')?.crenau?.heureDebut + ' à ' + item?.listRendezVous?.find(e => e.typeRendezVous === 'RACCORDEMENT')?.crenau?.heureFin
                                                        }</p>
                                                    </div>
                                                ) : null
                                            }


                                            <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                                                <p className="text-xs flex gap-1 items-center font-medium"><HomeIcon />{item?.batiment?.designation}</p>
                                                <p className="text-xs flex gap-1 font-medium"><ArchiveIcon /> {item?.equipement?.designation} </p>
                                            </div>

                                        </div>
                                        <h1 className="my-2 text-[13px] font-medium flex items-center"><SewingPinFilledIcon />{item?.commune + ", " + item?.quartier}</h1>
                                        <div className="flex items-center gap-1">
                                            <h5 className="text-xs font-medium ">
                                                Etape:
                                            </h5>
                                            <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                                                {item?.status?.toLowerCase().replace(/_/g, ' ')}
                                            </p>
                                        </div>
                                        {checkTagValidity(perm) ? <NavLink className='btn btn-sm bg-main my-3 font-mtn text-xs font-regular' to={`poursuivre-intention/${item?.numeroTicket}/${step}`}>Poursuivre</NavLink> : null}
                                    </div>

                                </div>
                            ))
                            :
                            <ContentLoading />
                }

            </div>
            <div className="my-3 flex justify-end">
                <Pagination
                    onChange={(event, newValue) => more(newValue)}
                    onSelect={(selectedPage) => more(selectedPage)}
                    count={intentions?.data?.totalPages}
                    variant="outlined"
                    color="primary"
                    shape="rounded"
                />
            </div>
        </>
    )
}
